import { get } from "../GenericServices";

const ProjectTask = {
  getProjectTasksAndPhasesOfProject: (queryString) => {
    return get(`project-task?${queryString}`);
  },
};

export default ProjectTask;
